import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import { toOmnichannelMessageBody } from '@/lib/helpers/omnichannel-media';
import type {
  RequestResponse,
  SendMessagePayload,
  SendTemplateMessagePayload,
  ChannelType,
  WhatsAppCoexistenceConnectPayload,
  WhatsAppCoexistenceAccount,
} from '@/types';

export const sendOmnichannelMessage = async (payload: SendMessagePayload) => {
  const body = toOmnichannelMessageBody(payload);
  const response = await axiosInstance.post<RequestResponse<unknown>>(
    `${endpoints.omnichannel.conversations}/${payload.conversationId}/messages`,
    body
  );
  return response.data;
};

export const sendOmnichannelTemplateMessage = async (
  payload: SendTemplateMessagePayload
) => {
  const response = await axiosInstance.post<RequestResponse<unknown>>(
    `${endpoints.omnichannel.conversations}/${payload.conversationId}/messages`,
    {
      pageId: payload.pageId,
      channel: payload.channel,
      to: payload.to,
      templateId: payload.templateId,
      templateVariables: payload.templateVariables,
    }
  );
  return response.data;
};

export const markOmnichannelConversationRead = async (
  conversationId: string
) => {
  const response = await axiosInstance.post<RequestResponse<unknown>>(
    endpoints.omnichannel.conversationMarkRead(conversationId)
  );
  return response.data;
};

export const deleteOmnichannelMessage = async (messageId: string) => {
  const response = await axiosInstance.delete<RequestResponse<unknown>>(
    `${endpoints.omnichannel.messages}/${messageId}`
  );
  return response.data;
};

export const connectOmnichannelChannel = async (channel: ChannelType) => {
  const response = await axiosInstance.post<RequestResponse<string>>(
    endpoints.omnichannel.connect,
    { channel }
  );
  return response.data;
};

export const disconnectOmnichannelChannel = async (channel: ChannelType) => {
  const response = await axiosInstance.delete<RequestResponse<null>>(
    endpoints.omnichannel.disconnect,
    { params: { channel } }
  );
  return response.data;
};

export const connectWhatsAppCoexistence = async (
  payload: WhatsAppCoexistenceConnectPayload
) => {
  const response = await axiosInstance.post<
    RequestResponse<WhatsAppCoexistenceAccount>
  >(endpoints.omnichannel.connectWhatsappCoexistence, payload);
  return response.data;
};
